<template>
  <div class="alipay-container">
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tradeMarkList' }">商标管理</el-breadcrumb-item>
        <el-breadcrumb-item>商标详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="hover">
      <div slot="header" class="card-header-title">商标详情信息</div>
      <div class="detail-info">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="商标名称">{{ info.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="注册号">{{ info.reg_sn || '-' }}</el-descriptions-item>
          <el-descriptions-item label="商标类别">{{ info.category_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请日期">{{ info.apply_date || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{ info.cont_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ info.telephone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="所属行业">{{ info.industry_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="getStatusType(info.status)" size="small">{{ getStatusText(info.status) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="商标地址" span="2">{{ info.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="备注" span="2">{{ info.remark || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="detail-footer">
        <el-button @click="$router.go(-1)">返回列表</el-button>
        <el-button type="primary" @click="goEdit">编辑</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name:'tradeMarkInfo',
  data(){
    return{
      id:'',
      info:{}
    }
  },
  created(){
    this.id = this.$route.query.id;
    this.loadData();
  },
  methods:{
    loadData(){
      // 模拟接口
      this.info = {
        name:'云程',reg_sn:'TM2025001',category_name:'第35类广告销售',
        apply_date:'2025-01-15',cont_name:'张三',telephone:'13800001111',
        industry_name:'互联网/电商',status:0,address:'浙江省杭州市',remark:'无'
      }
    },
    getStatusType(s){return s==1?'success':s==2?'danger':'warning'},
    getStatusText(s){return s==1?'已通过':s==2?'已驳回':'待审核'},
    goEdit(){this.$router.push({path:'/tradeMarkForm',query:{id:this.id}})}
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {padding:16px 20px;background:#f5f7fa;min-height:calc(100vh - 60px);}
.breadcrumb-wrapper{margin-bottom:16px;}
.alipay-card{border-radius:12px;}
.card-header-title{font-weight:500;font-size:16px;}
.detail-info{margin:20px 0;}
.detail-footer{display:flex;justify-content:center;gap:12px;margin-top:20px;}
</style>